import {Pressable, Text, View, Image} from "react-native";
import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useTheme} from "@react-navigation/native";
import * as Google from "expo-auth-session/providers/google";
import {useTranslation} from "react-i18next";
import {FontAwesome} from "@expo/vector-icons";
import {makeRedirectUri} from "expo-auth-session";

export default function AuthButton(props) {
    const settings = useSelector(state => state.settings);
    const [token, setToken] = useState("");
    const [userInfo, setUserInfo] = useState(null);
    const [request, response, promptAsync] = Google.useAuthRequest({
        androidClientId: '260442800327-4946giuq2d8vpifkkh6rcbkhln1jdr3h.apps.googleusercontent.com',
        iosClientId: '260442800327-4946giuq2d8vpifkkh6rcbkhln1jdr3h.apps.googleusercontent.com',
        webClientId: '260442800327-ihv37f57ur4q038g4eq8vqi66scpufmc.apps.googleusercontent.com',
        expoClientId: '260442800327-8o4m7h1ejiv7qt0o7ndt2678t5eija4i.apps.googleusercontent.com',
        redirectUri: makeRedirectUri({
            scheme: 'whatsonthelist'
        }),
    });
    const {t, i18n} = useTranslation();
    const theme = useTheme();
    useEffect(() => {
        if (response?.type === "success") {
            setToken(response.authentication.accessToken);
            getUserInfo();
        }
    }, [response, token]);
    const getUserInfo = async () => {
        try {
            const response = await fetch(
                "https://www.googleapis.com/userinfo/v2/me",
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            const user = await response.json();
            setUserInfo(user);
        } catch (error) {
            // Add your own error handler here
        }
    };
    const styles = {
        authButton: {
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent:'center',
            width:32,
            height:32,
            borderRadius:32,
            backgroundColor: theme.colors.scheme[4]
        },
        icon: {
            fontSize:16
        }
    }
    return (<View style={settings.auth.enabled ? {display:'flex', flexDirection:'row', alignItems:'center'} : {display:'none'}}>

        {(userInfo === null || userInfo?.error) ? (
            <Pressable
                title="Sign in with Google"
                disabled={!request}
                style={({pressed}) => [styles.authButton, {opacity:pressed ? 0.5 : 1}]}
                onPress={() => {
                    promptAsync({
                        projectNameForProxy: "@instantdynamic/taskapp"
                    });
                }}
            ><FontAwesome style={styles.icon} name={('sign-in')} /></Pressable>
        ) : (
            <View style={{display:'flex', flexDirection:'row', flexWrap:'nowrap'}}>
                <View style={{borderRadius:32, overflow:'hidden', marginRight:8}}>
                    <Image style={{width:32, height:32}}
                        source={{
                            uri: userInfo.picture,
                        }}
                    />
                </View>
                <Pressable style={({pressed}) => [styles.authButton, {opacity:pressed ? 0.5 : 1}]}
                                  onPress={() => {
                                      setUserInfo(null);
                                  }}>
                    <FontAwesome style={styles.icon} name={('sign-out')} />
                </Pressable>
            </View>
        )}
    </View>)
}